import { render, staticRenderFns } from "./modalEditSportCompetition.vue?vue&type=template&id=e4d40820&"
import script from "./modalEditSportCompetition.vue?vue&type=script&lang=js&"
export * from "./modalEditSportCompetition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports